import React from 'react';
import './WatermarkBackground.css';

const WatermarkBackground = () => {
  return (
    <div className="watermark-background">
      <img 
        src="/images/watermark/watermark.png" 
        alt="Watermark" 
        className="watermark-image"
      />
    </div>
  );
};

export default WatermarkBackground;
